var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  viewBox: "0 0 25 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 11.5,
  stroke: "currentColor",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.514 8-4.892 5.843-3.041-3.925L7 11.143l4.561 5.888 6.486-7.747z"
}))));
export default SvgCheckCircle;